import { combineReducers } from "@reduxjs/toolkit";
import { HYDRATE } from "next-redux-wrapper";

import cart, { CartActions } from "./cart";
import cartDispensary, { CartDispensaryActions } from "./cartDispensary";
import complianceRuleset, { ComplianceRulesActions } from "./complianceRules";
import config, { ConfigActions } from "./config";
import deals, { DealsActions } from "./deals";
import dispensary, { DispensaryActions } from "./dispensary";
import header, { HeaderActions } from "./header";
import location, { LocationActions } from "./location";
import menuItem, { MenuItemActions } from "./menuItem";
import order, { OrderActions } from "./order";
import search, { SearchActions } from "./search";
import shop, { ShopActions } from "./shop";
import user, { UserActions } from "./user";

export type HydrationState = {
  hasHydrated?: boolean;
};

const combinedReducer = combineReducers({
  cart,
  cartDispensary,
  complianceRuleset,
  config,
  deals,
  dispensary,
  header,
  hydration: (state: HydrationState | undefined) => state || {},
  location,
  menuItem,
  order,
  search,
  shop,
  user,
});

export type RootState = ReturnType<typeof combinedReducer>;

export type HydrateAction = {
  type: typeof HYDRATE;
  payload: RootState;
};
export type AllActions =
  | HydrateAction
  | ConfigActions
  | CartActions
  | CartDispensaryActions
  | ComplianceRulesActions
  | DealsActions
  | DispensaryActions
  | HeaderActions
  | LocationActions
  | MenuItemActions
  | OrderActions
  | SearchActions
  | ShopActions
  | UserActions;

const rootReducer = (state: RootState | undefined, action: AllActions) => {
  // This will apply all state from the initial SSR hydration to the client's state.
  // This should only happen once when the frontend parses the initial state from SSR.
  // Subsequent calls to HYDRATE, like when you do a client-side page navigation, should fall through to: combinedReducer(state, action)
  // allowing you to handle the hydration in a reducer.
  if (action.type === HYDRATE && !state?.hydration?.hasHydrated) {
    return combinedReducer(
      {
        ...(state || {}),
        ...action.payload,
        hydration: {
          hasHydrated: true,
        },
      },
      action
    );
  } else {
    return combinedReducer(state, action);
  }
};

export default rootReducer;
